import axios from 'axios';

interface EnvironmentApi {
	api: {
		seoByChain: string;
	}
}

interface Chain {
	storeId: string;
}

const getProductSeoData = (seoToken: string, host: string, environment: EnvironmentApi, chain: Chain, additionalHeaders: object): Promise<any> => {
	const seorequestUrl = `${environment.api.seoByChain}seo-category/v1/categories?seoUrl=${seoToken}&storeId=${chain.storeId}&children=true&published=true`;

	const httpHeaders = {
		'X-TIMEOUT': '7500',
		'Content-Type': 'application/json',
		origin: `${host}`,
		...additionalHeaders
	};

	const httpOptions = {
		headers: httpHeaders
	};

	// Make the XHR
	return axios.get(seorequestUrl, httpOptions).then((seoResponse) =>
		// Return just the data from the Axios response
		 seoResponse.data
	).catch(() =>
		// Return undefined
		 undefined
	);
};

export { getProductSeoData };